import CryptoJS from "crypto-js";
import { CRYPTO_SECRET_KEY } from "./utilities";

export const encrypt = (value) => {
    if (value) {
        try {
        const encryptedValue = CryptoJS.AES.encrypt(JSON.stringify(value), CRYPTO_SECRET_KEY).toString();
        return encryptedValue;
        }
        catch (error) {
            console.error('Encryption error:', error);
            return null;
        }
    }   
    else{
        return null;
    }
};

export const decrypt = (value) => {
    if (value) {
        try {
        const decryptedValueBytes = CryptoJS.AES.decrypt(value, CRYPTO_SECRET_KEY);
        const decryptedValueData = JSON.parse(decryptedValueBytes.toString(CryptoJS.enc.Utf8));
        return decryptedValueData;
        }
        catch (error) {
            console.error('Decryption error:', error);
            return null;
        }
    
    }
    else{
        return null;
    }
};